import SummaryMetrics from "../../../../components/Reports/SummaryMetrics";
import { PnlBreakdown } from "../../../../getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { useSummaryMetrics } from "reports/utils/metricUtils";
import { MetricEnum } from "reports/utils/metricTypes";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

import { handleCustomTitle } from "../eosUtils";

const DEFAULT_SUMMARY_METRICS = [
  { name: MetricEnum.AVAIL },
  { name: MetricEnum.TAGGING },
];
export default function GenericSummaryMetrics({
  data,
  processGroupName,
}: {
  data: PnlBreakdown;
  processGroupName?: string;
}) {
  // TODO Remove uneeded metrics
  const reportConfig = useReportConfig();
  const summaryMetricsRow1 = useSummaryMetrics({
    metrics:
      reportConfig?.eosReportMetricsConfig?.summaryMetricsRow1 ??
      DEFAULT_SUMMARY_METRICS,
    pnlBreakdown: data,
  });

  // TODO Remove uneeded metrics
  const summaryMetricsRow2 = useSummaryMetrics({
    metrics: reportConfig?.eosReportMetricsConfig?.summaryMetricsRow2 ?? [],
    pnlBreakdown: data,
  });

  const metricsExplainerArr = [
    ...summaryMetricsRow1,
    ...summaryMetricsRow2,
  ].map(metric => ({
    name: metric.name,
    description: metric.description,
    nameTranslated: metric.nameTranslated,
  }));

  return (
    <SummaryMetrics
      processGroupName={processGroupName}
      summaryMetrics={[summaryMetricsRow1, summaryMetricsRow2]}
      metricsExplainer={metricsExplainerArr}
      customReportTitle={
        reportConfig?.eosReportGeneralConfig?.customReportTitle
          ? handleCustomTitle(
              reportConfig?.eosReportGeneralConfig.customReportTitle,
              { processGroupName }
            )
          : undefined
      }
    />
  );
}
